export const primary_blue = "#2D7295";
export const primary_red = "#AE5257";
export const primary_yellow = "#E19E58";
export const secondary_green = "#83A67B";
export const secondary_pink = "#EAB3CE";

export const text1 = "#FFFFFF";
export const text2 = "#F3F3F3";
export const text3 = "#DEDEDE";
export const text4 = "#CCCCCC";
export const text5 = "#999999";

export const divider = "#999999";
export const background = "#222222";
export const background2 = "#666666";
export const background3 = '#434343';

export const semantic_negative = "#C80000";
export const semantic_warning = "#FFB700";
export const semantic_positive = "#59C900";
export const semantic_informative = "#0075FF";

export const backgroundBlur = "#434343";
export const gray300 = "#CCCCCC";
export const gray500 = "#999999";
export const gray700 = "#666666";
export const gray800 = "#434343";
